import $ from 'jquery';

/**
 * @desc Implements scroll "back to top" with native smooth scrolling.
 * It requires polyfill for browsers don't support this standard yet.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior}
 * @see {@link https://github.com/iamdustan/smoothscroll}
 */
export default class BackToTop {
  /**
   * @param {string} buttonSelector
   * @param {string} hoverClassName
   */
  constructor(buttonSelector, hoverClassName = 'back-to-top--hovered') {
    this.$buttonBackToTop = $(buttonSelector);
    this.hoverClassName = hoverClassName;

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.$buttonBackToTop.length) {
      this.isInitialized = false;

      return;
    }

    // TODO: Move a code below to a separate method (for instance 'attachEventListeners')

    this.$buttonBackToTop.hover(
      (event) => {
        $(event.currentTarget).addClass(this.hoverClassName);
      },
      (event) => {
        $(event.currentTarget).removeClass(this.hoverClassName);
      },
    );

    this.$buttonBackToTop.click((event) => {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });

      const $button = $(event.currentTarget);

      $button.blur();
      $button.removeClass(this.hoverClassName);
    });
  }
}
